<div class="container">
  <div>
    <ion-row>





      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">

        <!-- <div *ngIf="setupNotCompleted" style="color: red;">
          Not Completed Set Up
        </div> -->
        <button type="button" class="add_btn fs-14 float-right center-content mr-5"
          [style.background-color]="buttonColorName" (click)="addCandidate()">
          <span class="material-icons fs-20 mr-5">add</span>Add Candidate</button>


      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox mb-20">


    <ion-row>
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="ml-20 mt-20">
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">

        </mat-form-field>
      </ion-col>
      <ion-col class="mt-20">
        <label>
          <ion-label class="fs-14 font_regular pr-10 black_color ml-10 ">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
        </label>
      </ion-col>


      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="d-flex justify-content-flex-end ">
          <div class="d-flex" style="margin-right: 15px; margin-top: 10px;">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="downloadEmployeeList()">download</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <div class="p-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
              <thead>
                <tr>

                  <th *ngFor="let item of OfferAndAppointmentTableHeader" class="fs-14 font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style">
                      {{ item?.label }}

                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let employee of employees; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ employee.salutation }}</td>
                  <td class="name"
                  [ngClass]="{'disabled': employee.status === 'OFFER_LETTER_SENT' || employee.status === 'APPROVED_APPOINTMENT_LETTER'}"
                  [ngStyle]="{'color': 'orange', 'text-decoration': 'underline', 'cursor': (employee.status === 'OFFER_LETTER_SENT' || employee.status === 'APPROVED_APPOINTMENT_LETTER') ? 'default' : 'pointer'}"
                  (click)="(employee.status !== 'OFFER_LETTER_SENT' && employee.status !== 'APPROVED_APPOINTMENT_LETTER') ? employeeApplicationForm(employee) : null"
                >
                  {{ employee.firstName }}
                </td>
                

                  <!-- <td (click)="employeeApplicationForm(employee)"style="color: orange; text-decoration: underline; cursor: pointer;"
                  [disabled]="employee.status!='OFFER_LETTER_SENT' || employee.status=='APPROVED_APPOINTMENT_LETTER'">{{ employee.firstName}}</td> -->
                  <td>{{ employee.lastName }}</td>
                  <td>{{ employee.candidateEmail }}</td>
                  <td> {{ formatedataVariable(employee.status) }}</td>
                  <td>
                    
                    <img src="././assets/icon/blueEyeIcon.svg" matTooltip="View offer Letter" class="cp"
                      (click)="viewOferLatter(employee)"    *ngIf="!appointment"
                      [ngClass]="{'disabled': employee.status == 'FILLED_BY_EMPLOYEE_PENDING_BY_HR'||employee.status == 'NOT_FILLED_BY_EMPLOYEE'}||employee.fileName!=null||isLoading">
                    <mat-icon matTooltip="Send offer Letter" style="width: 32px;" (click)="sendOferLatter(employee)" *ngIf="!appointment"
                      [ngClass]="{'disabled': (employee.fileName==null || employee.status=='OFFER_LETTER_SENT'||employee.status=='APPROVED_APPOINTMENT_LETTER')}">send</mat-icon>
                    <!-- <i class="bi bi-send"></i> -->
                    <button type="button" class="add_btn fs-14 float-right center-content mr-5 custom-disabled-button"
                      [disabled]="employee.status!='OFFER_LETTER_SENT'" [style.background-color]="'green'" *ngIf="!appointment"
                      (click)="convertEmployeeCode(employee)">
                      Convert</button>
                      <button type="button" class="add_btn fs-14 float-right center-content mr-5 custom-disabled-button"
                      [disabled]="employee.status!='FILLED_BY_HR'" [style.background-color]="'green'" *ngIf="appointment"
                      (click)="convertEmployeeCode(employee)">
                      Convert</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>